var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59415 3.7348V5.11481H4.67414V2.81479C4.67414 2.69279 4.72261 2.57578 4.80887 2.48951C4.89514 2.40325 5.01215 2.35478 5.13415 2.35478H18.0143C18.1363 2.35478 18.2533 2.40325 18.3396 2.48951C18.4258 2.57578 18.4743 2.69279 18.4743 2.81479V19.375C18.4743 19.497 18.4258 19.614 18.3396 19.7003C18.2533 19.7865 18.1363 19.835 18.0143 19.835H5.13415C5.01215 19.835 4.89514 19.7865 4.80887 19.7003C4.72261 19.614 4.67414 19.497 4.67414 19.375V17.075H5.59415V18.455V18.915H6.05416H17.0943H17.5543V18.455V3.7348V3.27479H17.0943H6.05416H5.59415V3.7348ZM5.59415 10.1749V10.6349H6.05416H12.0342V11.5549H6.05416H5.59415V12.0149V13.8178L2.19047 11.0949L5.59415 8.37194V10.1749Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.920011
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.edaef530.svg";
export { ForwardRef as ReactComponent };